module.exports = __webpack_public_path__ + "static/img/collect.9e4b01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/me-fav/collect.png
// module id = auVU
// module chunks = 1